<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>会员储值报表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequestBody.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
        v-if="reportTabName == 'day' || reportTabName == 'area'"
      >
      </el-date-picker>
      <el-date-picker
        v-model="reportRequestBody.selectMonth"
        type="monthrange"
        range-separator="至"
        size="mini"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="selectReportDataMonth"
        value-format="yyyy-MM"
        v-if="reportTabName == 'month'"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择门店"
                 style="width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>

      <el-button size="mini" style="margin-left: 5px;" @click="loadKpiData(reportTabName)">查询</el-button>
    </div>
    <el-tabs v-model="reportTabName" @tab-click="reportTabNameClick" type="border-card" style="height: 650px">
      <el-tab-pane label="日业绩" name="day"></el-tab-pane>
      <el-tab-pane label="月业绩" name="month"></el-tab-pane>
      <el-tab-pane label="年业绩" name="year"></el-tab-pane>
      <el-tab-pane label="区域业绩" name="area" v-if="orgLevel<3"></el-tab-pane>
      <div>
        <el-table height="550px" :data="kpiDataList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  ref="tableName"

                  show-summary>
          <el-table-column
            align="center"
            prop="reportDate"
            label="日期"
            width="150"
            v-if="reportTabName === 'day'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="reportYearMonth"
            label="月份"
            width="150"
            v-if="reportTabName === 'month'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="reportYear"
            label="年份"
            width="150"
            v-if="reportTabName === 'year'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="areaName"
            label="区域"
            width="150"
            v-if="reportTabName === 'area' && orgLevel == 1"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="shopName"
            label="门店"
            width="150"
            v-if="reportTabName === 'area' && orgLevel == 2"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="syHyYe"
            :default-sort="{ order: 'descending' }" sortable
            label="剩余会员余额"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="hyCz"
            label="会员储值"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="syBdHy"
            label="使用本店会员"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="syTdHy"
            label="使用他店会员"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="tdSyBdHy"
            label="他店使用本店会员"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="bdHyTf"
            label="本店会员退费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="bdHyTdTf"
            label="本店会员他店退费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="fbdHyTf"
            label="非会员他店退费"
            width="150"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      orgId:'',
      orgLevel:'',
      authorities:'',
      performanceDate:'',
      tableTitle:[],
      kpiDataList:[],
      area:[],
      shop:[],
      users:[],
      selectAreaId:'',
      selectOrgId:'',
      selectUserId:'',
      reportTabName:'day',
      reportRequestBody:{
        selectDay:'',
        startDate:'',
        endDate:'',
        selectMonth:'',
        startMonth:'',
        endMonth:'',
        oneLevelHeader:'',
        shopId:0,
        areaId:0,
        orgId:'',
        userId:'',
        orgLevel:'',
        userName:''
      },
      towLevelDataDialogVisible:false,
      towLevelTitle:[],
      towLevelDataList:[],
      tabName:'day',
      dayTip:false,
      monthTip:false,

    }
  },
  methods:{
    reportTabNameClick(tab, event){
      this.reportTabName = tab.name;
      this.reportRequestBody.selectDay='';
      this.reportRequestBody.selectMonth='';
      this.reportRequestBody.shopId='';
      this.reportRequestBody.orgId='';
      this.reportRequestBody.userId='';
      this.selectAreaId='';
      this.selectOrgId='';
      this.kpiDataList = [];
      this.loadKpiData(tab.name);
    },
    async getArea(data){
      if (data !== ''){
        this.reportRequestBody.areaId = data;
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
        this.shop = res.data;
      } else {
        this.reportRequestBody.areaId = 0;
      }
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopId = data;
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.users = res.data;
      } else {
        this.reportRequestBody.shopId = 0;
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    loadKpiData(reportTabName){
      this.reportRequestBody.startDate='';
      this.reportRequestBody.endDate='';
      this.reportRequestBody.startMonth='';
      this.reportRequestBody.endMonth='';

      if (reportTabName ==='day'){
        this.loadKpiDataByDay();
      }
      if (reportTabName ==='month'){
        this.loadKpiDataByMonth();
      }
      if (reportTabName ==='year'){
        this.loadKpiDataByYear();
      }
      if (reportTabName ==='area'){
        this.loadKpiDataByArea();
      }

      this.$nextTick(() => {
        this.$refs.tableName.doLayout();
        // el-table添加ref="tableName"
      });
    },
    async loadKpiDataByDay(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }

      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }

      const {data:res} = await this.$http.post(`/report/hy/cz/day`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByMonth(){
      if (this.reportRequestBody.selectMonth !== '' && this.reportRequestBody.selectMonth != null){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      const {data:res} = await this.$http.post(`/report/hy/cz/month`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByArea(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== ''){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      const {data:res} = await this.$http.post(`/report/hy/cz/area`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByYear(){
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      // await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/report/hy/cz/year`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },

    selectReportDataDay(data){
      if (data == null){
        this.reportRequestBody.selectDay = '';
      } else {
        this.reportRequestBody.selectDay = data;
      }
    },
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
      }
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    exportKpiData(reportTabName){
      this.reportRequestBody.startDate='';
      this.reportRequestBody.endDate='';
      this.reportRequestBody.startMonth='';
      this.reportRequestBody.endMonth='';

      if (reportTabName ==='day'){
        this.exportKpiDataByDay();
      }
      if (reportTabName ==='month'){
        this.loadKpiDataByMonth();
      }
      if (reportTabName ==='year'){
        this.loadKpiDataByYear();
      }
      if (reportTabName ==='area'){
        this.loadKpiDataByArea();
      }
    },
    async exportKpiDataByDay(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      // this.$http.post('/export/performance/data/oneLevel/day', this.reportRequestBody, { responseType: 'blob' })
      //   .then((resp) => {
      //     if (!resp) {
      //       console.log('下载数据返回空')
      //       return
      //     }
      //     const link = document.createElement('a');
      //     let blob = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
      //     link.style.display = 'none';
      //     link.href = URL.createObjectURL(blob);
      //     link.setAttribute('download', '课程列表信息' + '.xls');
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //   })
    },
  },

  created() {
    this.dayTip = true;
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      // this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      this.loadShop();
    }
    if (this.orgLevel == 3){
      // this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.shopId = this.orgId;
    }
    this.loadKpiData('day');
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
  //overflow: auto !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
/deep/.el-table__body-wrapper .is-scrolling-left{
  height: 483px;
}
/deep/.el-tabs__content.el-table__fixed{
  height: 539px;
}
/deep/ .el-table__fixed{
  height: 100% !important;
}
/deep/ .el-table__fixed-right,.el-table__fixed-body-wrapper{
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ReportHyCz.vue